import BaseRoute from 'seshy/routes/base';
import { service } from '@ember/service';
import { action } from '@ember/object';
import { hash } from 'rsvp';

export default class AuthenticatedPlaylistsShowTeamsIndexRoute extends BaseRoute {
  @service currentUser;
  @service store;

  async model() {
    console.log('playlist teams route model');
    var playlist = this.modelFor('authenticated.playlists.show').playlist;
    var userTeams = this.store.findAll('team');
    var teamPlaylists = this.store.query('team-playlist', {
      filter: { playlistId: playlist.id },
      include: 'team',
    });
    console.log('playlist = ', playlist);
    //console.log('user_teams = ', userTeams);
    //console.log('teamProjects = ', teamProjects);
    return hash({
      playlist: playlist,
      userTeams: userTeams,
      teamPlaylists: teamPlaylists,
    });
  }

  @action
  routeRefresh() {
    //console.log('routeRefresh');
    this.refresh();
  }
}
